import { validateCompanion, type CompanionPlan } from "@japangolmok/core";
import { COMPANION_STORE, getAllRecords, getRecord, openDb } from "./db";

export async function listCompanions() {
  const rows = await getAllRecords<CompanionPlan>(COMPANION_STORE);
  if (rows.some((row) => validateCompanion(row, false) || row.schemaVersion !== 1)) throw new Error("INVALID_COMPANION");
  return rows.sort((a, b) => b.updatedAt.localeCompare(a.updatedAt));
}
export const getCompanion = (id: string) => getRecord<CompanionPlan>(COMPANION_STORE, id);

// Compare and write in one transaction: an old tab must not replace a newer plan.
export async function saveCompanion(plan: CompanionPlan, expectedRevision: number | null) {
  const error = validateCompanion(plan, expectedRevision === null);
  if (error) throw new Error(error);
  await mutate(plan.id, expectedRevision, plan);
}
export const removeCompanion = (plan: CompanionPlan) => mutate(plan.id, plan.revision, null);
async function mutate(id: string, expectedRevision: number | null, plan: CompanionPlan | null) {
  const db = await openDb();
  try {
    await new Promise<void>((resolve, reject) => {
      const tx = db.transaction(COMPANION_STORE, "readwrite");
      const store = tx.objectStore(COMPANION_STORE);
      let failure: Error | null = null;
      const read = store.get(id);
      read.onsuccess = () => {
        const previous = read.result as CompanionPlan | undefined;
        if ((previous?.revision ?? null) !== expectedRevision) { failure = new Error("COMPANION_CONFLICT"); tx.abort(); return; }
        if (plan) store.put({ ...plan, revision: (expectedRevision ?? 0) + 1 });
        else store.delete(id);
      };
      tx.oncomplete = () => resolve();
      tx.onerror = () => reject(failure ?? tx.error);
      tx.onabort = () => reject(failure ?? tx.error ?? new Error("SAVE_FAILED"));
    });
  } finally { db.close(); }
}
